import React from 'react';
import ExtraMaterialForm from '../../../components/forms/ExtraMaterialForm';

export default function ExtraMaterialsCreatePage() {
  return <ExtraMaterialForm />;
}
